import { useContext } from 'react';
import useCURD_Queries from '../queryGenerals/useCURD_Queries';
import { GlobalContext } from '../../../App';
import { removeItem, updateOrAddItem, useAddData, useGetData, useGetDataByName, useUpdateData } from '../../dataLocal/indexedDBHooks';

const getUserIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('שגיאה בקבלת כתובת IP:', error);
    return null;
  }
};

const useAreaGraveQueries = () => {
  const { setDataAreaGraves, userId, db } = useContext(GlobalContext);
  const { AllDataEntities, addOrUpdateDataEntity2, removeEntity } = useCURD_Queries();

  const addData = useAddData(db, 'myStore');
  const updateData = useUpdateData(db, 'myStore');
  const getDataByName = useGetDataByName(db, 'myStore');

  const AllDataAreaGraves = async (page = 1, limit = 50) => {
    try {
      let query = `api/areaGraves/getAreaGraves`;
      let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`;
      let nameEntity = 'dataAreaGraves';

      // קריאה ל-AllDataEntities עם פרמטרים של עמוד ומספר פריטים
      const data = await AllDataEntities(url, nameEntity, page, limit);

      // עדכון הנתונים ב-Context או ב-IndexedDB
      setDataAreaGraves(data?.resData || []);

      if (db) {
        // שמירת הנתונים ב-IndexedDB אם הם קיימים
        getDataByName(nameEntity)
          .then((existingData) => {
            if (existingData.length > 0) {
              // אם הנתונים קיימים, נעדכן אותם
              updateData({ id: 5, name: nameEntity, value: data?.resData || [] })
                .then(() => getDataByName(nameEntity))
                .catch((error) => console.error('Error updating data:', error));
            } else {
              // אם הנתונים לא קיימים, נכניס אותם כנתונים חדשים
              addData({ id: 5, name: nameEntity, value: data?.resData || [] })
                .then(() => getDataByName(nameEntity))
                .catch((error) => console.error('Error adding data:', error));
            }
          })
          .catch((error) => console.error('Error getting data by name:', error));
      }
    } catch (error) {
      console.error('שגיאה בטעינת נתונים: ', error);
    }
  };

  const addOrUpdateDataAreaGrave1 = async (data, unicId) => {
    let create = `api/areaGraves/addAreaGrave`;
    let update = `api/areaGraves/updateAreaGrave`;
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${data?.id ? update : create}`;

    let ip = '';
    // דוגמה לשימוש בפונקציה
    await getUserIP().then((myIp) => {
      ip = myIp;
    });

    let areaGrave = { ...data };
    delete areaGrave?.insertGraves;
    delete areaGrave?.updateGraves;
    delete areaGrave?.removeGraves;

    // נתונים מינימליים לשליחה לשרת
    const payload = {
      userId,
      recordId: data?.unicId,
      ipAddress: ip,
      tableName: 'areaGraves',
      actionType: data?.unicId ? 'UPDATE' : 'INSERT',
      oldValue: null,
      newValue: data,
      insertGraves: data?.insertGraves,
      updateGraves: data?.updateGraves,
      removeGraves: data?.removeGraves
    };

    if (!data?.unicId) {
      areaGrave = {
        ...areaGrave,
        unicId: unicId
      };
    }

    console.log('step data: ', data);
    console.log('step areaGrave: ', areaGrave);
    console.log('step insertGraves: ', data?.insertGraves);

    // try {
    //   let res = await addOrUpdateDataEntity2(areaGrave, payload, url);
    //   if (res) {
    //     console.log('חסר');
    //     console.log(areaGrave);

    //     updateOrAddItem(db, 'myStore', areaGrave, 'dataAreaGraves', 5);

    //     const graves = [
    //       ...(payload?.insertGraves || []),
    //       ...(payload?.updateGraves || [])
    //     ];

    //     graves?.forEach((item, i) => {
    //       updateOrAddItem(db, 'myStore', item, 'dataGraves', 6);
    //     });

    //     payload?.removeGraves?.forEach((item) => {
    //       removeItem(db, 'myStore', areaGrave.id, 5)
    //         .then((updatedList) => {
    //           console.log('Updated list after removal:', updatedList);
    //         })
    //         .catch((error) => {
    //           console.error('Error removing item:', error);
    //         });
    //     })

    //     console.log('התוצאה הצליחה...');
    //     return res;
    //   } else {
    //     return false;
    //   }
    // } catch (error) {
    //   console.error('שגיאה בתהליך העדכון/הוספה:', error);
    //   return false;
    // }
  };
  const addOrUpdateDataAreaGrave = async (data, unicId) => {
    let create = `api/areaGraves/addAreaGrave`;
    let update = `api/areaGraves/updateAreaGrave`;
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${data?.id ? update : create}`;

    let ip = '';
    // דוגמה לשימוש בפונקציה
    await getUserIP().then((myIp) => {
      ip = myIp;
    });

    let areaGrave = { ...data };
    delete areaGrave?.insertGraves;
    delete areaGrave?.updateGraves;
    delete areaGrave?.removeGraves;

    let areaGraveSever = { ...areaGrave };
    delete areaGraveSever?.cemeteryId;
    delete areaGraveSever?.blockId;
    delete areaGraveSever?.plotId;
    delete areaGraveSever?.cemeteryNameHe;
    delete areaGraveSever?.blockNameHe;
    delete areaGraveSever?.plotNameHe;
    delete areaGraveSever?.lineNameHe;

    const insertGravesServer = Array.isArray(data?.insertGraves) ? data.insertGraves.map(({ areaGraveNameHe, cemeteryId, blockId, plotId, lineId, cemeteryNameHe, blockNameHe, plotNameHe, lineNameHe, ...rest }) => ({ ...rest })) : [];

    const updateGravesServer = Array.isArray(data?.updateGraves) ? data.insertGraves.map(({ areaGraveNameHe, cemeteryId, blockId, plotId, lineId, cemeteryNameHe, blockNameHe, plotNameHe, lineNameHe, ...rest }) => ({ ...rest })) : [];

    const removeGravesServer = Array.isArray(data?.removeGraves) ? data.insertGraves.map(({ areaGraveNameHe, cemeteryId, blockId, plotId, lineId, cemeteryNameHe, blockNameHe, plotNameHe, lineNameHe, ...rest }) => ({ ...rest })) : [];

    // delete insertGravesServer?.areaGraveNameHe
    // delete insertGravesServer?.cemeteryId
    // delete insertGravesServer?.blockId
    // delete insertGravesServer?.plotId
    // delete insertGravesServer?.lineId
    // delete insertGravesServer?.cemeteryNameHe
    // delete insertGravesServer?.blockNameHe
    // delete insertGravesServer?.plotNameHe
    // delete insertGravesServer?.lineNameHe

    // let updateGravesServer = { ...data?.updateGraves }
    // delete updateGravesServer?.areaGraveNameHe
    // delete updateGravesServer?.cemeteryId
    // delete updateGravesServer?.blockId
    // delete updateGravesServer?.plotId
    // delete updateGravesServer?.lineId
    // delete updateGravesServer?.cemeteryNameHe
    // delete updateGravesServer?.blockNameHe
    // delete updateGravesServer?.plotNameHe
    // delete updateGravesServer?.lineNameHe

    // let removeGravesServer = { ...data?.removeGraves }
    // delete removeGravesServer?.areaGraveNameHe
    // delete removeGravesServer?.cemeteryId
    // delete removeGravesServer?.blockId
    // delete removeGravesServer?.plotId
    // delete removeGravesServer?.lineId
    // delete removeGravesServer?.cemeteryNameHe
    // delete removeGravesServer?.blockNameHe
    // delete removeGravesServer?.plotNameHe
    // delete removeGravesServer?.lineNameHe

    // נתונים מינימליים לשליחה לשרת
    const payload = {
      userId,
      recordId: data?.unicId,
      ipAddress: ip,
      tableName: 'areaGraves',
      actionType: data?.unicId ? 'UPDATE' : 'INSERT',
      oldValue: null,
      newValue: data,
      insertGraves: insertGravesServer,
      updateGraves: updateGravesServer,
      removeGraves: removeGravesServer
    };

    if (!data?.unicId) {
      areaGraveSever = {
        ...areaGraveSever,
        unicId: unicId
      };
    }

    try {
      let res = await addOrUpdateDataEntity2(areaGraveSever, payload, url);
      if (res) {
        updateOrAddItem(db, 'myStore', areaGrave, 'dataAreaGraves', 5);

        const graves = [...(data?.insertGraves || []), ...(data?.updateGraves || [])];

        graves?.forEach((item, i) => {
          updateOrAddItem(db, 'myStore', item, 'dataGraves', 6);
        });

        payload?.removeGraves?.forEach((item) => {
          removeItem(db, 'myStore', areaGrave.id, 5)
            .then((updatedList) => {
              console.log('Updated list after removal:', updatedList);
            })
            .catch((error) => {
              console.error('Error removing item:', error);
            });
        });

        console.log('התוצאה הצליחה...');
        return res;
      } else {
        return false;
      }
    } catch (error) {
      console.error('שגיאה בתהליך העדכון/הוספה:', error);
      return false;
    }
  };

  const removeAreaGrave = (id) => {
    let query = `api/areaGraves/removeAreaGrave`;
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`;
    removeEntity(id, url);
  };

  return {
    AllDataAreaGraves,
    addOrUpdateDataAreaGrave,
    removeAreaGrave
  };
};

export default useAreaGraveQueries;
